export default __webpack_public_path__ + "static/media/target-9@3x.49a3bab2.png";